import { Spin } from 'antd';
import React from 'react';
import styled from 'styled-components';

const LoadingWrapper = styled.div`
  height: auto;
  width: 100%;
  .chart-overlay-loader{
    height: 350px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: none;
    &:hover {
      border: none;
    }
  }
`;

const ChartSpinner = function ChartSpinner() {
  return (
    <LoadingWrapper>
      <div className="tabs-item chart-overlay-loader">
        <Spin />
      </div>
    </LoadingWrapper>
  );
};

export default ChartSpinner;
